import React, { useContext } from "react";

import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import PostContext from "../../context/post/postContext";
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import { makeStyles } from "@material-ui/core/styles";
import DeleteIcon from "@material-ui/icons/Delete";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));


const PostDeleteModal = ({ id }) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  const handleOpen = (e) => {
    e.preventDefault();
    setOpen(true);
  };

  const handleClose = (e) => {
    e.preventDefault();
    setOpen(false);
  };

  const postContext = useContext(PostContext);

  const { deletePost } = postContext;

  const onDelete = () => {
    deletePost(id);
  };

  return (
    <div>
      <IconButton
        aria-label="delete"
        data-target={`model-${id}`}
        onClick={handleOpen}
      >
        <DeleteIcon />
      </IconButton>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className={classes.paper}>
            <h3 id="transition-modal-description">
              Are you sure to delete this post?
            </h3>
            <Button onClick={handleClose} style={{ margin: "20px" }}>
              Cancel
            </Button>
            <Button
              onClick={onDelete}
              variant="contained"
              style={{ margin: "20px", background: "#03a9f4" }}
              color="primary"
            >
              Delete
            </Button>
          </div>
        </Fade>
      </Modal>
    </div>
  );
};

export default PostDeleteModal;
